import { Box, CircularProgress, Step, StepLabel, Stepper } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { IS_SA } from '../../../../../config/appConfig';
import { AppRoutes } from '../../../../../constants/appRoutes';
import { InvestorRegistrationStep } from '../../../../../constants/investorRegistrationSteps';
import { InvestorStepperContext } from '../../../../../context/investorStepperContext';
import { buildLocalizeRoute } from '../../../../../helpers/languageHelper';
import { setRegistrationData } from '../../../../../services/authService';
import { InvestorRegService } from '../../investorRegService';
import { UserService } from '../../../../../services/userService';
import { UserTermsConditionDialog } from '../../../components/userTermsAndConditionDialog';

export const InvestorStepper = () => {
	const investorService = new InvestorRegService();
	const userService = new UserService();
	const [loading, setLoading] = useState(true);
	const { steps, handleStepper, setIsKsaInternationalInvestor } = useContext(InvestorStepperContext);
	const [showtAndCPopup, setShowtAndCPopup] = useState(false);
	const { pathname, state } = useLocation();
	const { t } = useTranslation();
	const [selectedStep, setSelectedStep] = useState(-1);

	const navigate = useNavigate();

	useEffect(() => {
		getInvestorRegistrationData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		let path = pathname.split('/');
		let lastPathName = path[path.length - 1];
		if (lastPathName && steps && steps?.length) {
			setSelectedStep(steps.findIndex((resp) => lastPathName === resp.path));
		}
	}, [pathname, steps]);

	const getInvestorRegistrationData = () => {
		investorService
			.getInvestorRegistrationData()
			.then((resp) => {
				const isKsaInternationalInvestor = !!state?.isKsaInternationalInvestor || (localStorage.getItem("isKsaInternationalInvestor") === '1');
				setIsKsaInternationalInvestor(!!isKsaInternationalInvestor);
				if (IS_SA) {
					if (!!isKsaInternationalInvestor) localStorage.setItem("isKsaInternationalInvestor", '1');
					else localStorage.removeItem("isKsaInternationalInvestor");
				}
				if (resp.data) {
					setRegistrationData(resp.data);
				}
				const investorType = resp.data?.investorType;
				onHandleStepsRefresh(resp.data?.step, isKsaInternationalInvestor);

				if (investorType) {
					handleStepper(investorType);
				}
				const shouldUseGlobalTerms = !IS_SA || isKsaInternationalInvestor;
				if (shouldUseGlobalTerms) {
					getCheckIfTAndCCompleted();
				} else {
					if (resp.data?.termsConditionsAccepted === false) {
						setShowtAndCPopup(true);
					}
					setLoading(false);
				}
			})
			.catch((err) => {
				setLoading(false);
			});
	};

	const getCheckIfTAndCCompleted = () => {
		userService.getTandCCompleted().then(resp => {
			setLoading(false);
			if (!resp.data) {
				setShowtAndCPopup(true);
				// onSubmitTermsCondition();
			}
		}).catch(err => { setLoading(false); });
	};

	// const onSubmitTermsCondition = () => {
	// 	investorService.submitTermsCondition().then(resp => { }).catch(err => { });
	// };

	const onHandleStepsRefresh = (step, isKsaInternationalInvestor) => {
		let route = null;
		if (step === InvestorRegistrationStep.NotStarted || step === -1) {
			const alreadyOnPersonalInfo = window.location.pathname.includes(AppRoutes.IRegPersonalInfo);
			if (alreadyOnPersonalInfo && isKsaInternationalInvestor) {
				route = AppRoutes.IRegPersonalInfo;
			} else {
				const shouldGoToNafath = IS_SA && !isKsaInternationalInvestor;
				route = shouldGoToNafath ? AppRoutes.IRegNafathVerification : AppRoutes.IRegPersonalInfo;
			}
		} else if (step === InvestorRegistrationStep.PersonalInformation) {
			route = AppRoutes.IRegPersonalInfo;
		} else if (step === InvestorRegistrationStep.DocumentVerification) {
			route = AppRoutes.iRegDocumentVarification;
		}
		if (route && !window.location.pathname.includes(`${AppRoutes.InvestorRegistration}/${route}`)) {
			navigate(
				buildLocalizeRoute(`${AppRoutes.InvestorRegistration}/${route}`)
			);
		}
	};

	return (
		<Box className="flex justify-center items-center">
			<Box className="md:w-[850px] w-full">
				<Stepper
					data-testid="investorStepper"
					className="my-4 mb-8"
					orientation="horizontal"
					activeStep={selectedStep}
					alternativeLabel>
					{steps.map((resp) => (
						<Step key={resp?.name}>
							<StepLabel>
								<span
									className="font-bold"
									data-testid={`investor-${resp?.name}`}>
									{t(`investor-${resp?.name}`)}
								</span>
							</StepLabel>
						</Step>
					))}
				</Stepper>
				{!loading ? (
					<Outlet></Outlet>
				) : (
					<Box className="flex justify-center items-center reg-section-height">
						<CircularProgress data-testid={'loader'} />
					</Box>
				)}
			</Box>
			{showtAndCPopup ? <UserTermsConditionDialog state={showtAndCPopup} onClose={() => {
				setShowtAndCPopup(false);
			}} /> : null}
		</Box>
	);
};
